import VueScrollTo from 'vue-scrollto';
/* все связанное с авторизацией должно быть в auth */
import Security from '@/_helpers/security.js';
import auth from '@/routes_new/outer/auth/index.vue';
import auth_routes from '@/routes_new/outer/auth/routes.js';

import interview from '@/routes_new/outer/interview/index.vue';
import interview_routes from '@/routes_new/outer/interview/routes.js';

import interview_tests from '@/routes_new/outer/interview/landing/tests/index.vue';
import InterviewIntegration from '@/routes_new/outer/interview/landing/integration/InterviewIntegration';
import interview_tests_routes from '@/routes_new/outer/interview/landing/tests/routes.js';
import interview_video from '@/routes_new/outer/interview/landing/video/index.vue';
import interview_survey from '@/routes_new/outer/interview/landing/application/index.vue';

// import online_interview from '@/routes_new/outer/online_interview/view_record/index.vue';
const online_interview = () => import('@/routes_new/outer/online_interview/view_record');

import online from '@/routes_new/outer/online_interview/index.vue';

import public_response from '@/routes_new/outer/response/index.vue';

import processOuter from '@/process/routes.js';

import TalentqFinishPage from '@/routes_new/outer/talentq/TalentqFinishPage';

const Registration = () => import('@/routes_new/outer/auth/registration/registration');

export default [
  {
    path: '',
    component: auth,
    children: auth_routes
  },
  {
    path: '',
    component: interview,
    children: interview_routes
  },
  // temp registration form. delete it after include new component
  {
    path: 'registration/:lang',
    name: 'registration',
    props: true,
    component: Registration,
    meta: {
      title: 'pageTitles.routes.registration',
      isOuter: true
    }
  },
  {
    path: 'registration',
    name: 'registration',
    props: true,
    component: Registration,
    meta: {
      title: 'pageTitles.routes.registration',
      isOuter: true
    }
  },
  {
    path: 'tq/finish-page',
    name: 'TalentqFinishPage',
    meta: { isOuter: true },
    component: TalentqFinishPage
  },
  {
    path: 'p/:token',
    props: true,
    meta: {
      title: 'pageTitles.routes.responses.response',
      public_response: true,
      isOuter: true
    },
    component: public_response,
    alias: '/public-responses/:token'
  },
  {
    path: 'tests',
    components: {
      default: interview_tests
    },
    props: true,
    children: interview_tests_routes
  },
  {
    path: 'external-integration/:token',
    name: 'interview-integration',
    components: {
      default: InterviewIntegration
    },
    meta: { isOuter: true },
    props: {
      default: route => ({
        token: route.params.token
      })
    }
  },
  {
    path: '/record/:token',
    name: 'record',
    components: {
      default: interview_video
    },
    props: {
      default: route => ({
        token: route.params.token
      })
    },
    meta: {
      title: 'pageTitles.routes.interviews.root',
      contentWrapperVideointerview: true,
      is_adaptive: true,
      isOuter: true
    }
  },
  {
    path: 'online/:token',
    beforeEnter: Security.auth_check,
    components: {
      default: online
    },
    props: {
      default: route => ({ token: route.params.token })
    },
    name: 'online-outer',
    meta: {
      title: 'pageTitles.routes.online-interview.root',
      online_interview: true,
      isOuter: true
    }
  },
  {
    path: 'online-interview/:token',
    beforeEnter: Security.auth_online,
    components: {
      default: online_interview
    },
    name: 'online-interview-outer',
    props: {
      default: route => ({ token: route.params.token })
    },
    meta: {
      title: 'pageTitles.routes.online-interview.root',
      headerOptions: { fixed: false },
      isOuter: true
    }
  },
  {
    path: '/survey/:token',
    name: 'survey',
    beforeEnter: (to, from, next) => {
      VueScrollTo.scrollTo(document.querySelector('.main'), 0);
      next();
    },
    components: {
      default: interview_survey
    },
    props: {
      default: route => ({
        token: route.params.token
      })
    },
    meta: {
      title: 'pageTitles.routes.interviews.root',
      contentWrapperVideointerview: true,
      is_adaptive: true,
      isOuter: true
    }
  }
].concat(processOuter);
